export default ($options) => Object.assign({
  parent: null,
  path: null,
  enableEvents: true,
  definition: null,
  propertyClasses: [],
}, $options)